import { FilterOption } from "@components/inbox/NoteFilters";
import { useAuth, useTeam } from "@hooks";
import { useState } from "react";

import TeamFilterDropdown from "./TeamFilterDropdown";
import { getSelectedTeamMemberName } from "./utils";

export const AnonymousTeamFilterDropdown = ({
  selectedTeamMembers,
  setSelectedTeamMembers,
}) => {
  const [activeFilter, setActiveFilter] = useState(null);
  const { userUuid } = useAuth();
  const hasTeamFilter =
    (userUuid !== selectedTeamMembers[0] ||
      selectedTeamMembers.length > 1) &&
    selectedTeamMembers.length > 0;

  const { currentTeam } = useTeam();
  const clearTeamFilter = () => {
    setSelectedTeamMembers([userUuid]);
  };

  const filterOptionValue = getSelectedTeamMemberName(
    selectedTeamMembers,
    currentTeam,
    userUuid,
  );

  return (
    <FilterOption
      label="My Templates"
      isActive={activeFilter === "My Templates"}
      setActiveFilter={setActiveFilter}
      isApplied={hasTeamFilter}
      onClear={clearTeamFilter}
      value={filterOptionValue}
      dataTestId="templates-filter"
    >
      <TeamFilterDropdown
        isActive={activeFilter === "My Templates"}
        currentTeam={currentTeam}
        selectedTeamMembers={selectedTeamMembers}
        setSelectedTeamMembers={setSelectedTeamMembers}
        refreshCurrentTeam={() => {}}
      />
    </FilterOption>
  );
};
